import { render, staticRenderFns } from "./blobs.vue?vue&type=template&id=524de895"
import script from "./blobs.vue?vue&type=script&lang=js"
export * from "./blobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports